export const EMAIL_BUILDER_ACTION_RAIL_ATTR = "data-email-builder-action-rail";
export const EMAIL_BUILDER_ACTION_RAIL_SELECTOR = `[${EMAIL_BUILDER_ACTION_RAIL_ATTR}]`;
